import React from 'react';
import Footer from '../components/Footer';
import styles from './Resume.module.css';

const Resume = () => (
    <div className="Page">
        <main className={styles.resumePage}>
            <iframe
                className={styles.resumeDocument}
                src="/Freed Resume.pdf#toolbar=0&navpanes=0&scrollbar=0&view=FitH"
                title="Ethan Freed resume"
            />
            <img
                className={styles.printResumeDocument}
                src="/resume-print.png"
                alt="Ethan Freed resume"
            />
        </main>
        <Footer />
    </div>
);

export default Resume;
